import React from "react";
import IMemo from "../Sections/ElementsSections/Forms/Components/IMemo";

// eslint-disable-next-line @typescript-eslint/naming-convention
export default function OutPut() {
  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        overflow: "hidden",
      }}
    >
      <IMemo
        id={"OutPutInput"}
        style={{
          height: "100%",
          width: "100%",
          resize: "none",
          overflow: "auto",
          outline: "none",
        }}
      />
    </div>
  );
}
